import HistoryDetails from "@/shared/model/HistoryDetails";

export default class HistoryDetailsString extends HistoryDetails {
  value?: string
}
